import {FUIAbstractInput} from "../../framework/abstract-input";
import {ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {FUIResponsiveService} from "../../../page/responsive.service";
import {Subscription} from "rxjs";
import {FUISpanningFixtureComponent} from "../../framework/fixtures/spanning-fixture/spanning-fixture.component";
import {FUIBreakpoints} from "../../../page/breakpoints.model";
import {FUIIconComponent} from "../../../icons/icon/icon.component";

@Directive()
export abstract class FUIAbstractLocalisationInput extends FUIAbstractInput implements OnDestroy, OnInit {
    @ViewChild(FUIIconComponent, {static: true}) fixtureIcon: FUIIconComponent
    @ViewChild(FUISpanningFixtureComponent, {static: true}) public spanningFixture: FUISpanningFixtureComponent;

    private _localised: boolean;
    private subscriptions: Subscription = new Subscription();

    constructor(protected responsiveService: FUIResponsiveService,
                changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
        this.subscriptions.add(this.responsiveService.windowWidth$.subscribe(() => this.configureIcon()));
    }

    ngOnInit(): void {
        this.configureIcon();
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }

    configureIcon() {
        if (this.fixtureIcon && this.spanningFixture) {
            if (this.responsiveService.breakpointApplies(FUIBreakpoints.mediumUp)) {
                this.fixtureIcon.height = 24;
                this.fixtureIcon.width = 24;
                this.spanningFixture.active = false;
            } else {
                this.fixtureIcon.height = 12;
                this.fixtureIcon.width = 12;
                this.spanningFixture.active = true;
            }
            if (this._localised) {
                this.fixtureIcon.icon = "globe-marker";
            } else {
                this.fixtureIcon.icon = "globe";
            }
            this.changeDetectorRef.detectChanges();
        }
    }

    /**
     * Return localised private property
     * @returns {boolean}
     */
    get localised(): boolean {
        return this._localised;
    }

    /**
     * Set localised and update the relevant icon
     * @param {boolean} localised
     */
    @Input()
    set localised(localised: boolean) {
        if (this._localised != localised) {
            this._localised = localised;
            this.configureIcon();
        }
    }

    /**
     * Override default click action
     */
    public override click(): void {
    }
}
